import { Stack, TextField } from '@fluentui/react';
import { Button } from '@h2oai/ui-kit';
import { type ChangeEvent, useRef } from 'react';

import { OperationErrorDisplay } from './OperationErrorDisplay';

interface ControlsSectionProps {
  onFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  onCreateDirectory: () => void;
  isUploading: boolean;
  operationErrors: Array<{ type: string; message: string }>;
  canWrite: boolean;
  canRead: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onShareDirectory?: () => void;
}

export const ControlsSection = (props: ControlsSectionProps) => {
  const {
    onFileUpload,
    onCreateDirectory,
    isUploading,
    operationErrors,
    canWrite,
    canRead,
    searchQuery,
    onSearchChange,
    onShareDirectory,
  } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  if (!canRead) return null;

  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <Stack tokens={{ childrenGap: 8 }}>
        <Stack horizontal tokens={{ childrenGap: 8 }} horizontalAlign="space-between">
          <TextField
            placeholder="Search files..."
            value={searchQuery}
            onChange={(_, newValue) => onSearchChange(newValue || '')}
            iconProps={{ iconName: 'Search' }}
            styles={{
              root: { width: 300 },
            }}
            data-test="drive-search-input"
          />
          <Stack horizontal tokens={{ childrenGap: 8 }}>
            {canWrite && (
              <Stack horizontal tokens={{ childrenGap: 8 }}>
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  onChange={onFileUpload}
                  disabled={isUploading}
                  style={{ display: 'none' }}
                />
                <Button
                  iconName="Add"
                  text="Add"
                  menuItems={[
                    {
                      key: 'upload-files',
                      text: 'Upload Files',
                      'data-test': 'upload-files',
                      onClick: handleUploadClick,
                      disabled: isUploading,
                      iconProps: { iconName: 'BulkUpload' },
                    },
                    {
                      key: 'create-directory',
                      text: 'Create directory',
                      'data-test': 'create-directory',
                      onClick: onCreateDirectory,
                      disabled: isUploading,
                      iconProps: { iconName: 'FabricNewFolder' },
                    },
                  ]}
                />
              </Stack>
            )}
            <Button iconName="Share" text="Share" onClick={onShareDirectory} data-test="share-directory-button" />
          </Stack>
        </Stack>
        <Stack>
          {operationErrors.map((error, index) => (
            <OperationErrorDisplay key={`${error.type}-${index}`} error={error as any} />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
